export default __webpack_public_path__ + "images/H1.b465d36.png";